'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { getCountryFlag } from '../../../../../utils/helpers'
import { getCountryDisplayName } from '@/countryDisplay'
import { useStorefrontMarket } from '@/useStorefrontMarket'

export const CountryLink = () => {
  const pathname = usePathname()
  const { currencyCode, countryIsoCode, brandCode } = useStorefrontMarket()
  const countryCode = countryIsoCode

  const countryName = getCountryDisplayName(countryCode)

  return countryCode ? (
    <Link
      href={`/currency?ref=${encodeURIComponent(pathname)}`}
      prefetch={false}
      className="min-w-16 max-w-[calc(100vw-7rem)] sm:max-w-[17rem] md:max-w-[20rem] text-center hover:cursor-pointer hover:bg-red-800 rounded-sm flex h-7 shrink-0 items-center justify-center overflow-hidden px-2 leading-none transition-colors focus:outline-hidden focus:ring-vi-red focus:ring-offset-gray-100"
    >
      <span className="sr-only">Change your shipping country and currency</span>

      <div className="flex items-center min-w-0">
        <span aria-hidden="true" className="text-sm leading-none">
          {getCountryFlag(countryCode, brandCode)}
        </span>
        <div className="text-white ml-1 uppercase font-medium text-[13px] leading-none flex items-center min-w-0">
          <span className="hidden sm:inline normal-case truncate">
            Ship to {countryName || countryCode}
          </span>
          <span className="sm:hidden">{countryCode.toUpperCase()}</span>
          <span className="mx-1 text-white/70">·</span>
          {currencyCode}
        </div>
      </div>
    </Link>
  ) : (
    <div className="animate-pulse bg-red-700 rounded-full w-16 h-6">&nbsp;</div>
  )
}
